import { Children, React, useEffect, useState } from "react";
import { Flex, Space, Splitter, Typography, Layout, Tabs, Image } from 'antd';
import {CloseOutlined} from '@ant-design/icons';
import TzolkinMain from './TzolkinMain';
import Logo from './Logo';
import MdText from "./MdText";
import maya from "./js/maya";
import KinShortDescription from "./components/KinShortDescription";
import TzolkinCharacter from "./TzolkinCharacter";

const TzolkinPage = (props) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentSign, setCurrentSign] = useState(0);
  const [currentTab, setCurrentTab] = useState("short");
  var currentMaya = maya.maya(currentDate);
  const [tabs, setTabs] = useState([
    {
      key: 'short',
      label: props.locale.kin+" "+currentMaya.kin,
      closable: false,
      children: (
      <Typography.Paragraph>
        <KinShortDescription kin={currentMaya.kin} lang={props.lang}/>
      </Typography.Paragraph>)
    }
  ]);
  useEffect(() => {
    var newtabs = tabs.map(tab => {
      if(tab.key == "short") {
        tab.label = props.locale.kin+' '+currentMaya.kin;
        tab.children = (
      <Typography.Paragraph>
        <KinShortDescription kin={currentMaya.kin} lang={props.lang}/>
      </Typography.Paragraph>);
      } else {
        tab = characterTabElem(tab.key.substring(9)*1, props.locale, props.lang);
      }
      return tab;
    });
    setTabs(newtabs);
  }, [currentDate, props.lang, props.locale]);
  const characterTabElem = (sign, locale, lang) => {
    return {
        key: 'character'+sign,
        label: locale.signs[sign],
        closable: true,
        closeIcon: (<CloseOutlined />),
        children: (
          <TzolkinCharacter sign={sign} locale={locale} lang={lang} selectSign={addCharacter}/>
        )
      }
  }
  const addCharacter = (sign) => {
    if(tabs.filter(tab => tab.key=='character'+sign).length == 0) {
      setCurrentTab('character'+sign);
      setTabs(tabs.concat(characterTabElem(sign, props.locale, props.lang)));
    }
  }
  const closeCharacter = (sign) => {
    var newtabs = tabs.filter(tab => tab.key!=sign);
    setTabs(newtabs);
    setCurrentTab(newtabs[newtabs.length-1].key);
  }
  return (
    <Space direction="vertical" style={{ width: '100%'}}>
    <Splitter lazy style={{maxHeight: '100%'}}>
        <Splitter.Panel
         defaultSize="30%"
         min="20%" 
         max="50%" 
         style={{height: "100%", minWidth: "320px"}}>
        <TzolkinMain
            date={currentDate}
            setDate={(date) => {setCurrentDate(date);setCurrentTab('short')}}
            selectSign={addCharacter}
            locale={props.locale}
        />
        </Splitter.Panel>
        <Splitter.Panel 
         collapsible={{start: true, end: true}}>
          <Tabs 
          type="editable-card"
          hideAdd
          items={tabs} 
          activeKey={currentTab} 
          onChange={(key) => setCurrentTab(key)}
          onEdit={(key, act) => closeCharacter(key)}/>
        </Splitter.Panel>
    </Splitter>
    </Space>
  );
}

export default TzolkinPage;
